import Dropdown from 'bootstrap/js/src/dropdown'
import each from 'lodash/each'

import { navigation } from '../utils/store'
import { media } from '../utils/media'

import gsap from 'gsap'
import ScrollToPlugin from 'gsap/ScrollToPlugin'

gsap.registerPlugin(ScrollToPlugin)

class Dropdowns {
    isNavMenuMobile(entry) {
        return Boolean(entry.closest('[data-navigation-menu]') && media('<iPadPortrait'))
    }

    clearPopperStyles(dropdownMenu) {
        ;['transform', 'top', 'left', 'right', 'bottom', 'inset', 'position'].forEach((prop) => {
            dropdownMenu.style.removeProperty(prop)
        })
    }

    closeNavMenuDropdowns(navMenu, exceptToggle = null) {
        if (!navMenu) {
            return
        }

        navMenu.querySelectorAll('[data-bs-toggle="dropdown"]').forEach((toggle) => {
            if (toggle === exceptToggle) {
                return
            }

            const instance = Dropdown.getInstance(toggle)

            if (instance) {
                instance.hide()
                return
            }

            const menu = toggle.nextElementSibling

            toggle.classList.remove('show')
            toggle.setAttribute('aria-expanded', 'false')

            if (menu?.classList.contains('dropdown-menu')) {
                menu.classList.remove('show')
                this.clearPopperStyles(menu)
            }
        })
    }

    closeAllInMenu(navMenu) {
        this.closeNavMenuDropdowns(navMenu)
    }

    create(entry) {
        const dropdownMenu = entry.nextElementSibling

        if (!dropdownMenu?.classList.contains('dropdown-menu')) {
            return
        }

        const isNavMenuMobile = this.isNavMenuMobile(entry)
        const instance = new Dropdown(entry, isNavMenuMobile ? { display: 'static' } : {})

        this.setHeight(entry)
        window.addEventListener('resize', () => this.setHeight(entry))

        if (isNavMenuMobile) {
            const navMenu = entry.closest('[data-navigation-menu]')

            entry.addEventListener('show.bs.dropdown', () => {
                this.closeNavMenuDropdowns(navMenu, entry)
                this.clearPopperStyles(dropdownMenu)
            })

            entry.addEventListener('shown.bs.dropdown', () => {
                this.clearPopperStyles(dropdownMenu)
            })

            dropdownMenu.querySelector('[data-closer]')?.addEventListener('click', (event) => {
                event.preventDefault()
                event.stopPropagation()
                instance.hide()
            })
        } else if (media('<iPadPortrait')) {
            entry.addEventListener('click', () => { this.onClick(entry) })
        }
    }

    setHeight = (entry, height = 0) => {
        each(entry.nextElementSibling.children, (child) => { height += child.clientHeight })
        entry.nextElementSibling.style.setProperty('--dropdownmenu-height', `${height}px`)
    }

    onClick = (entry, height = 0) => {
        each(entry.nextElementSibling.children, (child) => { height += child.clientHeight })

        if (entry.classList.contains('show')) {
            const scrollTop = navigation.current.scrollTop + height
            gsap.to(navigation.current, { duration: .4, scrollTo: scrollTop })
        }
    }
}

export const DropdownManager = new Dropdowns()
